module.exports = __webpack_public_path__ + "20250721160708/img/bj.4de6628e.png";